import React, { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { onboardingApi } from "api/onboardingApi";
import { useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { userAtom } from "../../../../recoil/userAtom";

export function OnboardingLoad() {
  const navigate = useNavigate();
  const user = useRecoilValue(userAtom);

  const {
    data: resp,
    isLoading,
    isSuccess,
    isError,
  } = useQuery(["onboardingLastPage"], () => onboardingApi.loadLastPage(), {
    cacheTime: 0,
    staleTime: 0, // 즉시 재요청하도록 staleTime도 0으로 설정하는 것이 좋습니다.
  });

  useEffect(() => {
    // 로딩이 끝나고 API 호출이 성공했을 때만 로직을 실행합니다.
    if (isSuccess) {
      const lastPageId = resp?.result?.pageId;

      // ➋ 서버에서 받아온 마지막 페이지 ID가 있는지 확인합니다.
      if (lastPageId) {
        const [type, seq] = lastPageId.split("_");

        // ➌ 받아온 정보로 URL을 직접 만들어 바로 이동합니다.
        //    URL의 유효성 검증 및 렌더링은 OnboardingScreen이 담당합니다.
        if (type && seq) {
          if (user?.isWebFunnelRegister) {
            if (type === "payment") {
              navigate("/onboarding_new/payment/1", { replace: true });
            } else if (type === "result" && (seq === "4" || seq === "5")) {
              navigate(`/onboarding_new/${type}/${seq}`, {
                replace: true,
              });
            } else {
              navigate("/onboarding_new/w2a-loading/1", { replace: true });
            }
          } else {
            navigate(`/onboarding_new/${type}/${seq}`, {
              replace: true,
            });
          }
        } else {
          // 만약 pageId 형식이 이상할 경우, 안전하게 첫 페이지로 보냅니다.
          if (user?.isWebFunnelRegister) {
            navigate("/onboarding_new/w2a-loading/1", { replace: true });
          } else {
            navigate("/onboarding_new/acquisition/1", { replace: true });
          }
        }
      } else {
        // ➍ 마지막 페이지 정보가 없으면 (신규 유저), 온보딩 첫 단계로 이동합니다.
        if (user?.isWebFunnelRegister) {
          navigate("/onboarding_new/w2a-loading/1", { replace: true });
        } else {
          navigate("/onboarding_new/acquisition/1", { replace: true });
        }
      }
    } else if (isError) {
      // ➎ API 에러 발생 시에도 안전하게 첫 페이지로 이동시킵니다.
      if (user?.isWebFunnelRegister) {
        navigate("/onboarding_new/w2a-loading/1", { replace: true });
      } else {
        navigate("/onboarding_new/acquisition/1", { replace: true });
      }
    }
  }, [isSuccess, isError, resp, navigate, user]);

  // 로딩 중이거나 리다이렉트 전에는 아무것도 렌더링하지 않습니다.
  return <></>;
}
